import { cn } from "@/shared/cn";
import { dismissToast, useToastMessage } from "@/shared/ui/overlays/toast";

export function ToastHost() {
  const message = useToastMessage();
  const action = message?.action;
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "pointer-events-none fixed bottom-[84px] left-1/2 z-[200] flex -translate-x-1/2 items-center gap-[10px] rounded-[9px]",
        "bg-(--ink) px-[14px] py-[8px] text-sm text-(--ground) transition-opacity duration-200",
        message ? "opacity-100" : "opacity-0",
      )}
    >
      {message?.text}
      {action && (
        <button
          type="button"
          onClick={() => {
            dismissToast();
            action.onSelect();
          }}
          className="pointer-events-auto h-[28px] cursor-pointer rounded-[9px] border border-[color-mix(in_srgb,var(--ground)_30%,transparent)] bg-transparent px-[10px] font-medium text-inherit"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
